export function trim(string: string): string {
  return string.replace(
    /^((<p>)?( |&nbsp;|<br \/>|<br>|\r|\n)(<\/p>)?)*(.*?)((<p>)?( |&nbsp;|<br \/>|<br>|\r|\n)(<\/p>)?)*$/,
    '$5',
  );
}
